var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDownDashed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#DBDDDD",
  d: "M5.47 27.53a.75.75 0 0 0 1.06 0l4.773-4.773a.75.75 0 0 0-1.06-1.06L6 25.939l-4.243-4.242a.75.75 0 1 0-1.06 1.06zM6.75 1a.75.75 0 0 0-1.5 0zm0 23.4a.75.75 0 0 0-1.5 0zm-1.5-3.467a.75.75 0 0 0 1.5 0zm1.5-5.2a.75.75 0 0 0-1.5 0zm-1.5-3.466a.75.75 0 0 0 1.5 0zm1.5-5.2a.75.75 0 1 0-1.5 0zM5.25 3.6a.75.75 0 0 0 1.5 0zM6.75 27v-2.6h-1.5V27zm0-6.067v-5.2h-1.5v5.2zm0-8.666v-5.2h-1.5v5.2zm0-8.667V1h-1.5v2.6z"
})));
export default SvgArrowDownDashed;